// DE content translations. Keyed `<type>.<id>.<field>`. From content-i18n workflow.
export const contentDe: Record<string, string> = {
  "card.trade-routes.name": "Handelsrouten",
  "card.trade-routes.desc": "+25% auf die gesamte Ressourcenproduktion.",
  "card.sharpened-tools.name": "Geschärfte Werkzeuge",
  "card.sharpened-tools.desc": "+35% Ernteschaden.",
  "card.wide-survey.name": "Weite Erkundung",
  "card.wide-survey.desc": "+20% Radius des Erntekreises.",
  "card.guild-labor.name": "Gildenarbeit",
  "card.guild-labor.desc": "+45% automatische Sammelrate.",
  "card.efficient-masons.name": "Effiziente Maurer",
  "card.efficient-masons.desc": "Gebäude kosten 15% weniger.",
  "card.standing-army.name": "Stehendes Heer",
  "card.standing-army.desc": "+40% Verteidigung und +10 Basisverteidigung.",
  "card.stone-walls.name": "Steinmauern",
  "card.stone-walls.desc": "+22 Basisverteidigung.",
  "card.drilled-ranks.name": "Gedrillte Truppen",
  "card.drilled-ranks.desc": "+20% Verteidigung und +8 Basisverteidigung.",
  "card.war-economy.name": "Kriegswirtschaft",
  "card.war-economy.desc": "+50% Verteidigung.",
  "card.watchtowers.name": "Wachtürme",
  "card.watchtowers.desc": "+15% Verteidigung und +12% Produktion.",
  "card.scholars.name": "Gelehrte",
  "card.scholars.desc": "+45% Wissensproduktion und Technologie.",
  "card.scientific-method.name": "Wissenschaftliche Methode",
  "card.scientific-method.desc": "+25% Wissen und +15% Produktion.",
  "card.enlightenment.name": "Aufklärung",
  "card.enlightenment.desc": "+30% Wissen und +12% Verteidigung.",
  "card.mass-schooling.name": "Allgemeine Schulbildung",
  "card.mass-schooling.desc": "+25% Wissen und +20% automatisches Sammeln.",
  "card.engineering.name": "Ingenieurwesen",
  "card.engineering.desc": "+20% Produktion und Gebäude kosten 10% weniger.",
  "synergy.industrial-revolution.name": "Industrielle Revolution",
  "synergy.industrial-revolution.desc": "Zwei Wirtschaftspfade vereinen sich: +50% Produktion.",
  "synergy.fortress.name": "Festung",
  "synergy.fortress.desc": "Zwei Militärpfade vereinen sich: +45% Verteidigung und +25 Basis.",
  "synergy.great-library.name": "Große Bibliothek",
  "synergy.great-library.desc": "Zwei Wissenspfade vereinen sich: +60% Wissen und +25% Produktion.",
  "synergy.renaissance.name": "Renaissance",
  "synergy.renaissance.desc": "Wirtschaft trifft Wissen: +30% Produktion und +30% Wissen.",
  "synergy.war-machine.name": "Kriegsmaschine",
  "synergy.war-machine.desc": "Wirtschaft trifft Militär: +20% Verteidigung und +25% Produktion.",
  "synergy.enlightened-guard.name": "Erleuchtete Wache",
  "synergy.enlightened-guard.desc": "Wissen trifft Militär: +20% Verteidigung und +30% Wissen.",
  "synergy.golden-age.name": "Goldenes Zeitalter",
  "synergy.golden-age.desc": "Alle drei Richtungen im Gleichgewicht: +35% Produktion und Wissen, +20% Verteidigung.",
  "skill.bountiful-start.name": "Reicher Start",
  "skill.bountiful-start.desc": "Beginne jeden Durchlauf mit mehr Holz, Stein und Erz.",
  "skill.settlers.name": "Siedler",
  "skill.settlers.desc": "Beginne jeden Durchlauf mit zusätzlicher Bevölkerung.",
  "skill.industrious.name": "Fleißig",
  "skill.industrious.desc": "+8% globale Produktion pro Stufe.",
  "skill.sharp-tools.name": "Scharfe Werkzeuge",
  "skill.sharp-tools.desc": "+10% Ernteschaden pro Stufe.",
  "skill.wide-reach.name": "Weite Reichweite",
  "skill.wide-reach.desc": "+10% Radius des Erntekreises pro Stufe.",
  "skill.fortified.name": "Befestigt",
  "skill.fortified.desc": "+12% Siedlungsverteidigung pro Stufe.",
  "skill.swift-hands.name": "Flinke Hände",
  "skill.swift-hands.desc": "+10% automatisches Sammeln pro Stufe.",
  "skill.long-memory.name": "Langes Gedächtnis",
  "skill.long-memory.desc": "+1 Stunde Offline-Limit pro Stufe.",
  "skill.war-chest.name": "Kriegskasse",
  "skill.war-chest.desc": "Beginne jeden Durchlauf mit Beute zum Ausgeben für Technologie.",
  "skill.archivist.name": "Archivar",
  "skill.archivist.desc": "+10% Wissen und Technologieverteidigung pro Stufe.",
  "skill.master-mason.name": "Meistermaurer",
  "skill.master-mason.desc": "Gebäude kosten 5% weniger pro Stufe.",
  "tech.irrigation.name": "Bewässerung",
  "tech.irrigation.desc": "+30% Produktion.",
  "tech.masonry.name": "Mauerwerk",
  "tech.masonry.desc": "Gebäude kosten 20% weniger.",
  "tech.cartography.name": "Kartografie",
  "tech.cartography.desc": "+30% Ernteradius und +25% Ernteschaden.",
  "tech.logistics.name": "Logistik",
  "tech.logistics.desc": "+75% automatisches Sammeln.",
  "tech.conscription.name": "Wehrpflicht",
  "tech.conscription.desc": "+45% Verteidigung.",
  "tech.bulwark.name": "Bollwerk",
  "tech.bulwark.desc": "Boss-Vorbereitung: +35% Verteidigung und +40 Basisverteidigung.",
  "tech.surge.name": "Produktionsschub",
  "tech.surge.desc": "+150% Produktion für 25 Sekunden. Wiederholbar.",
  "artifact.double-harvest.name": "Zwillingssichel",
  "artifact.double-harvest.desc": "Doppelter Ernteertrag und +50% Ernteschaden.",
  "artifact.aegis.name": "Ägis-Kern",
  "artifact.aegis.desc": "Doppelte Siedlungsverteidigung.",
  "artifact.resource-magnet.name": "Magnetstein",
  "artifact.resource-magnet.desc": "+60% Produktion und +50% automatisches Sammeln.",
  "artifact.chronosphere.name": "Chronosphäre",
  "artifact.chronosphere.desc": "+50% mehr Zeit zwischen den Wellen.",
  "artifact.philosophers-stone.name": "Stein der Weisen",
  "artifact.philosophers-stone.desc": "Doppeltes Wissen und +30% Produktion.",
  "building.house.name": "Haus",
  "building.house.desc": "Beherbergt Siedler und erhöht Bevölkerung und Arbeitskraft.",
  "building.lumberCamp.name": "Holzfällerlager",
  "building.lumberCamp.desc": "Fällt automatisch Holz.",
  "building.quarry.name": "Steinbruch",
  "building.quarry.desc": "Bricht automatisch Stein.",
  "building.mine.name": "Mine",
  "building.mine.desc": "Fördert Erz und stärkt die gesamte Wirtschaft.",
  "building.barracks.name": "Kaserne",
  "building.barracks.desc": "Bildet Verteidiger aus und erhöht die Siedlungsverteidigung.",
  "building.school.name": "Schule",
  "building.school.desc": "Erzeugt Wissen und fördert Technologie und Verteidigung.",
  "resource.wood.name": "Holz",
  "resource.stone.name": "Stein",
  "resource.ore.name": "Erz",
  "resource.knowledge.name": "Wissen",
  // Calamities (v0.10)
  "calamity.quake.name": "Erdbeben",
  "calamity.quake.desc": "Der Boden riss unter der Siedlung auf. Die Speicher stürzten in die Spalten.",
  "calamity.flood.name": "Große Flut",
  "calamity.flood.desc": "Der Fluss stieg in der Nacht und nahm sich, was er wollte.",
  "calamity.drought.name": "Dürre",
  "calamity.drought.desc": "Die Brunnen versiegen. Unter dem flachen weißen Himmel wird alles langsamer.",
  "calamity.plague.name": "Seuche",
  "calamity.plague.desc": "Sie kam mit einer Karawane und blieb. Die Heiler taten, was sie konnten.",
  "calamity.great-fire.name": "Großbrand",
  "calamity.great-fire.desc": "Es begann in einem Kornspeicher. Bei Sonnenaufgang war ein ganzes Viertel Asche.",
  "calamity.collapse.name": "Der Einsturz",
  "calamity.collapse.desc": "Das große Bauwerk scheiterte. Die Baumeister beschuldigen einander.",
  "calamity.market-crash.name": "Marktkollaps",
  "calamity.market-crash.desc": "Der Beutemarkt brach über Nacht zusammen. Papiervermögen, Papierasche.",
  "calamity.embargo.name": "Handelsembargo",
  "calamity.embargo.desc": "Die Routen sind dicht. Die Karawanen warten an Grenzen, die einmal Linien auf einer Karte waren.",
  "calamity.unrest.name": "Unruhen",
  "calamity.unrest.desc": "Die Menge auf dem Platz hörte auf zu rufen und begann zu nehmen.",
  "calamity.exodus.name": "Der Exodus",
  "calamity.exodus.desc": "Eine Karawane zog vor Sonnenaufgang fort. Mit Zelten, Herden und Zweifeln.",
};
